import { create } from 'zustand';
export const useCarlineStore = create((set) => ({
    isDebugMode: false,
    setIsDebugMode: (isDebugMode) => {
        set({ isDebugMode });
    },
    actions: {},
    setActions: (actions) => {
        set({ actions });
    },
    financialDisclaimer: null,
    setFinancialDisclaimer: (financialDisclaimer) => {
        set({ financialDisclaimer });
    },
    carline: {},
    setCarline: (carline) => {
        set({ carline });
    },
    configuredCar: {},
    setConfiguredCar: (configuredCar) => {
        if (configuredCar) {
            set({ configuredCar });
        }
    },
    selectedEngine: null,
    setSelectedEngine: (selectedEngine) => {
        set({ selectedEngine });
    },
    secondSelectedEngine: null,
    setSecondSelectedEngine: (secondSelectedEngine) => {
        set({ secondSelectedEngine });
    },
    compare: false,
    setCompare: (compare) => {
        set({ compare });
    },
    appConfig: null,
    setAppConfig: (appConfig) => {
        set({ appConfig });
    },
    configuredCarline: {},
    setConfiguredCarline: (configuredCarline) => {
        set({ configuredCarline });
    },
    standardEquipmentInitialCar: [],
    setStandardEquipmentInitialCar: (standardEquipmentInitialCar) => {
        set({ standardEquipmentInitialCar });
    },
    standardEquipmentCompareCar: [],
    setStandardEquipmentCompareCar: (standardEquipmentCompareCar) => {
        set({ standardEquipmentCompareCar });
    },
}));
